import { Component } from '@angular/core';

@Component({
  selector: 'table[ui-table]',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  constructor() {}
}
